import styled from 'styled-components'

export const LoginPhoneNumberWrapper = styled.div`
	display: flex;
	flex-flow: row;
	justify-content: space-evenly;
	padding: 0% 4%;
`

export const InputWrapper = styled.input`
	width: ${(props) => (props.width ? props.width : '75%')};
	background-color: transparent;
	padding-left: 10px;
	letter-spacing: 0.15px;
	height: var(--it-hg-lg);
	border: 0px;
	border-bottom: 1px solid var(--border-color);
	color: var(--text-white-color);
	font-size: var(--fs-sm);
	font-weight: var(--fw-sm);
	margin-top: 41px;
	margin-right: var(--mg-xxs);
	&::placeholder {
		color: var(--placeholder-color);
	}
	&:focus {
		outline: dotted;
		outline-color: var(--border-color);
		border: none;
	}
`
